(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userStatusFilter', ['$filter', '$rootScope', 'UserRole', 'RoleType', 'UserBroadcast', 'UserFilterService', 'UserSearchPaginationService', UserStatusFilterFn]);

    // filter directive for user view
    function UserStatusFilterFn($filter, $rootScope, UserRole, RoleType, UserBroadcast, UserFilterService, UserSearchPaginationService) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-status-filter.template.html',
            scope: {
                active: '=',
                blocked: '=',
                deleted: '='
            }
        };
        return directive;

        function link(scope) {
            //activate directive
            activate();

            // filter list
            scope.filterActive = function ($event) { 

                $event.stopPropagation();

                //reset
                scope.numFilters = 0;

                // role change
                if (UserSearchPaginationService.data.active !== null) {
                    UserSearchPaginationService.data.active = !UserSearchPaginationService.data.active;
                }
                // refresh view
                refresh();
            };

            scope.filterBlocked = function ($event) { 

                $event.stopPropagation();

                // role change
                if (UserSearchPaginationService.data.blocked !== null) {
                    UserSearchPaginationService.data.blocked = !UserSearchPaginationService.data.blocked;
                }
                // refresh view
                refresh();
            };
            scope.filterDeleted = function ($event) { 

                $event.stopPropagation();

                // role change
                if (UserSearchPaginationService.data.deleted !== null) {
                    UserSearchPaginationService.data.deleted = !UserSearchPaginationService.data.deleted;
                }
                // refresh view
                refresh();
            };

            function refresh() {
                // refresh overview
                UserSearchPaginationService.search();
                // number of selected states
                scope.numFilters = 
                    UserSearchPaginationService.data.deleted + 
                    UserSearchPaginationService.data.blocked ;
            }

            // init work
            function activate() {
                UserSearchPaginationService.data.active = true;
                scope.numFilters = 0;
            } //activate
           
        } // link
    }
})();